$(function () {
  var clipboard = new ClipboardJS('.copy_text');

  clipboard.on('success', function (e) {
    toast('success', 'Đã sao chép ' + e.text);
    e.clearSelection();
  });

  clipboard.on('error', function (e) {
    toast('danger', 'Không thể sao chép. Vui lòng thử lại.');
  });
});
